import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import Button from "@components/buttons/Button";
import { Modal } from "@lib/modal";

import { useRootAppStore } from "@hooks";
import { isUserAuthenticated } from "@utils";

export default observer(function LogoutPopup() {
	const { t } = useTranslation("user-account");

	const { logoutPopupStore } = useRootAppStore();

	useEffect(() => {
		return () => {
			logoutPopupStore.onDispose();
		};
	}, []);

	if (!isUserAuthenticated()) {
		logoutPopupStore.deactivatePopup();
		return null;
	}

	if (!logoutPopupStore.isLogoutPopupActive) {
		return null;
	}

	return (
		<Modal>
			<div className="popup popup--logout">
				<div className="popup__card">
					<div className="popup__header popup--logout__header">
						<div className="popup__title">{t("INFO")}</div>

						<Button
							type="button"
							className="btn--square btn--square--sml btn--primary--inverted popup__close"
							iconOnly
							iconClassName="u-icon--tny u-icon--close"
							onClick={logoutPopupStore.deactivatePopup}
						/>
					</div>

					<div className="popup__body u-gap--base">
						<div className="popup__text u-type--center">
							<i className="u-icon u-icon--huge u-icon--alert-circle u-color--sent--warning u-icon--animated--bounce-in" />
						</div>

						<div className="popup__text">
							{t("LUGAS.LOGOUT_INFO")}
						</div>

						<div className="popup__text">
							{t("LUGAS.LOGOUT_INFO_OPTIONS")}
						</div>

						<dl className="popup__list popup__list--dl">
							<dt>{t("LUGAS.DEACTIVATE_ONLY_TITLE")}</dt>
							<dd>{t("LUGAS.DEACTIVATE_ONLY_DESC")}</dd>
						</dl>

						<dl className="popup__list popup__list--dl">
							<dt>{t("LUGAS.DEACTIVATE_AND_LOGOUT_TITLE")}</dt>
							<dd>{t("LUGAS.DEACTIVATE_AND_LOGOUT_DESC")}</dd>
						</dl>

						<div className="popup__text popup__text--subtle">
							{t("LUGAS.NOTE_INFO")}
						</div>
					</div>

					<div className="popup__footer popup__footer--bordered">
						<Button
							type="submit"
							className="popup__footer__btn popup--logout__btn btn btn--med btn--primary--inverted"
							btnText={t("LUGAS.DEACTIVATE_AND_LOGOUT")}
							onClick={async () => {
								await logoutPopupStore.deactiveAndLogout();
							}}
						/>

						<Button
							type="submit"
							className="popup__footer__btn popup--logout__btn btn btn--med btn--accent"
							btnText={t("LUGAS.DEACTIVATE")}
							onClick={async () => {
								await logoutPopupStore.deactivate();
							}}
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
});
